var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormik } from 'formik';
import { AiOutlineClose } from 'react-icons/ai';
import Modal from 'react-modal';
import useAuth from '../../../hooks/useAuth';
import api from '../../../services/api';
import styles from './styles.module.scss';
import { Button, InputSelect } from 'template/lib';
import { useEffect, useState } from 'react';
Modal.setAppElement('#root');
var ModalAddLibrarie = function (props) {
    var login = useAuth().login;
    var _a = useState([]), companies = _a[0], setCompanies = _a[1];
    var _b = useState([]), libraries = _b[0], setLibraries = _b[1];
    var _c = useState(null), selectedLibrary = _c[0], setSelectedLibrary = _c[1];
    var config = {
        headers: { Authorization: "Bearer " + (login === null || login === void 0 ? void 0 : login.token) },
    };
    // 🔹 Carrega lista de empresas
    useEffect(function () {
        api.get("/companies", config)
            .then(function (response) {
            var opts = response.data.map(function (item) { return ({
                id: item.id,
                name: item.name,
            }); });
            setCompanies(opts);
        })
            .catch(function (error) {
            console.error("Erro ao carregar empresas:", error);
        });
    }, []);
    // 🔹 Busca as bibliotecas da empresa selecionada
    var loadLibrariesByCompany = function (companyId) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, api.get("/companies/" + companyId + "/library", config)];
                case 1:
                    response = _a.sent();
                    // 🔹 Mantém todos os dados do retorno
                    setLibraries(response.data);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error("Erro ao carregar bibliotecas:", error_1);
                    setLibraries([]);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var formik = useFormik({
        initialValues: {
            CompanyId: '',
            LibrarieId: '',
            isChecked: false,
        },
        onSubmit: function (values, actions) { return __awaiter(void 0, void 0, void 0, function () {
            var companyId, data, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (!selectedLibrary) {
                            console.warn('Nenhuma biblioteca selecionada');
                            return [2 /*return*/];
                        }
                        companyId = values.CompanyId || props.idItem;
                        data = {
                            companyLibrary: companyId,
                            companyAuthorized: props.idItem,
                            details: selectedLibrary
                                ? selectedLibrary.name + " - " + new Date().toLocaleString('pt-BR')
                                : new Date().toLocaleString('pt-BR'),
                            library: (selectedLibrary === null || selectedLibrary === void 0 ? void 0 : selectedLibrary.id) || null,
                            main: values.isChecked,
                        };
                        return [4 /*yield*/, api.post("/companies/AddLib", data, config)
                                .then(function (response) {
                                if (response.data.message === "Esta empresa já possui essa biblioteca vinculada.") {
                                    props.setMessage(response.data.message);
                                    props.setAlertOpen(true);
                                }
                                // 🔹 Limpa o checkbox e demais campos controlados pelo Formik
                                formik.resetForm();
                                props.reload();
                                props.handleCloseModalAddLibrarie();
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        console.error("Erro ao adicionar biblioteca:", err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); },
    });
    var companyOptions = {
        label: 'Empresa Proprietária',
        options: companies,
    };
    var libraryOptions = {
        label: 'Biblioteca',
        options: libraries.map(function (lib) { return ({
            id: lib.id,
            name: lib.name,
        }); }),
    };
    var columns = 1;
    return (_jsx("div", __assign({ className: 'h-24' }, { children: _jsx(Modal, __assign({ isOpen: props.handleOpenModalAddLibrarie, shouldCloseOnOverlayClick: false, onRequestClose: props.handleCloseModalAddLibrarie, overlayClassName: 'react-modal-overly', className: 'react-modal-content', contentLabel: 'Adicionar Biblioteca' }, { children: _jsxs("div", { children: [_jsxs("div", __assign({ className: styles.header }, { children: [_jsx("div", {}, void 0), _jsx("h2", __assign({ className: 'font-semibold border-b-2 text-lg' }, { children: "Liberar Biblioteca" }), void 0), _jsx(AiOutlineClose, { title: 'Fechar', className: 'cursor-pointer text-sm', onClick: props.handleCloseModalAddLibrarie }, void 0)] }), void 0), _jsx("div", __assign({ className: styles.content }, { children: _jsxs("form", __assign({ onSubmit: formik.handleSubmit, className: 'mx-4 my-4' }, { children: [_jsx("div", __assign({ className: 'grid justify-items-start' }, { children: _jsxs("div", __assign({ className: "grid grid-cols-1 md:grid-cols-" + columns + " lg:grid-cols-" + columns + " my-2 justify-items-start", style: { marginRight: '109px' } }, { children: [_jsx(InputSelect, { name: 'CompanyId', valueMember: 'id', displayMember: 'name', values: companyOptions, value: formik.values.CompanyId, onChange: function (e) {
                                                    var selectedId = parseInt(e.target.value);
                                                    formik.setFieldValue('CompanyId', selectedId);
                                                    loadLibrariesByCompany(selectedId);
                                                }, firstOption: 'Selecione a empresa' }, void 0), _jsx(InputSelect, { name: 'LibrarieId', valueMember: 'id', displayMember: 'name', values: libraryOptions, value: formik.values.LibrarieId, onChange: function (e) {
                                                    var selected = libraries.find(function (lib) { return lib.id === parseInt(e.target.value); });
                                                    setSelectedLibrary(selected);
                                                    formik.setFieldValue('LibrarieId', (selected === null || selected === void 0 ? void 0 : selected.id) || '');
                                                }, firstOption: 'Selecione a Biblioteca' }, void 0), _jsxs("div", __assign({ className: styles.containerCheckBoxInput }, { children: [_jsx("label", __assign({ className: styles.labelImplantationa }, { children: "Principal?" }), void 0), _jsx("input", { onChange: formik.handleChange, name: 'isChecked', type: 'checkbox', checked: formik.values.isChecked }, void 0)] }), void 0)] }), void 0) }), void 0), _jsx("div", __assign({ className: styles.flexButton }, { children: _jsx(Button, __assign({ type: 'submit' }, { children: "Salvar" }), void 0) }), void 0)] }), void 0) }), void 0)] }, void 0) }), void 0) }), void 0));
};
export default ModalAddLibrarie;
